import { Box } from '@mui/system';
import DevicesListEnhanced from 'components/DevicesListEnhanced';

export const DevicesListManagement = () => {
  return (
    <Box>
      <DevicesListEnhanced />
    </Box>
  );
};